import dayjs from "dayjs";
import { YYYY_MM_DD_DATE_PATTERN } from "./regEx";

export const calcAgeByYear0 = (now: string, dob: string): number => {
  if (typeof dob !== "string" || !dob.match(YYYY_MM_DD_DATE_PATTERN)) {
    return -1;
  }

  const nowDayJs = dayjs(now).startOf("day");
  const dobDayJs = dayjs(dob).startOf("day");

  const currentYear = nowDayJs.year();
  const birthYear = dobDayJs.year();

  return Math.max(currentYear - birthYear, 0);
};

export const calcAgeByDay0 = (now: string, dob: string): number => {
  if (typeof dob !== "string" || !dob.match(YYYY_MM_DD_DATE_PATTERN)) {
    return -1;
  }

  const nowDayJs = dayjs(now).startOf("day");
  const dobDayJs = dayjs(dob).startOf("day");

  return nowDayJs.diff(dobDayJs, "year");
};
